(() => {
  const drawers = document.querySelectorAll('.brand-product-info-drawer');
  const root = document.documentElement;

  const syncScrollLock = () => {
    const hasOpenDrawer = Array.from(drawers).some((drawer) => drawer.hasAttribute('open'));
    root.classList.toggle('brand-product-drawer-open', hasOpenDrawer);
  };

  drawers.forEach((drawer) => {
    drawer.addEventListener('toggle', syncScrollLock);

    drawer.addEventListener('click', (event) => {
      if (
        event.target.closest('.brand-product-info-drawer__overlay') ||
        event.target.closest('.brand-product-info-drawer__close')
      ) {
        drawer.removeAttribute('open');
        syncScrollLock();
      }
    });
  });

  document.addEventListener('keyup', (event) => {
    if (event.key !== 'Escape') return;

    drawers.forEach((drawer) => drawer.removeAttribute('open'));
    syncScrollLock();
  });
})();
